import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import axios from 'axios'
import authInterceptor from "./interceptors/authInterceptor";
import status401Interceptor from "./interceptors/status401Interceptor";
import successInterceptor from "./interceptors/successInterceptor";
import errorInterceptor from "./interceptors/errorInterceptor";

const container = document.getElementById('root')!;
const root = createRoot(container);
axios.interceptors.request.use(authInterceptor)
axios.interceptors.response.use((config) => config, status401Interceptor)
axios.interceptors.response.use(successInterceptor, errorInterceptor);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
